import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { Globals } from "src/app/globals";
import { startWith, map } from "rxjs/operators";

@Component({
  selector: "app-entrada-seleccion-abierta",
  templateUrl: "./entrada-seleccion-abierta.component.html",
  styleUrls: ["./entrada-seleccion-abierta.component.css"]
})
export class EntradaSeleccionAbiertaComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Input() nombreControl: string;
  @Input() configCampo;
  @Input() valor;

  control = new FormControl("", [Validators.required]);
  lista = [];
  listaFiltrada: Observable<string[]>;
  etiqueta: any;
  nombreCampo: any;

  constructor(public global: Globals) {}

  ngOnInit() {
    if(this.valor){
      this.control.setValue(this.valor);
    }
    
    this.listaFiltrada = this.control.valueChanges.pipe(
      startWith(""),
      map(value => this._filtro(value))
    );

    this.parentForm.addControl(this.nombreControl, this.control);
    if(this.valor){
      this.control.setValue(this.valor);
    }
    if (this.global.lenguaje == "es") {
      this.llenarLista(this.configCampo.DatosSelectEspanol);
      this.etiqueta = this.configCampo.es;
      this.nombreCampo = this.configCampo.es;
    } else {
      this.llenarLista(this.configCampo.DatosSelectIngles);
      this.etiqueta = this.configCampo.en;
      this.nombreCampo = this.configCampo.en;
    }
  }

  llenarLista(listaRemota) {
    for (let i = 0; i < listaRemota.length; i++) {
      const elemento = listaRemota[i];
      this.lista.push(elemento.nombre);
    }
    //////conole.log(this.lista);
  }

  private _filtro(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.lista.filter(option => {
      return option.toLowerCase().includes(filterValue);
    });
  }
}
